"use strict";
// istanbul ignore file
var AbortController;
if (typeof window === 'undefined') {
    AbortController = require('abort-controller');
}
else {
    if ('signal' in new Request('')) {
        AbortController = window.AbortController;
    }
    else {
        var polyfill = require('abortcontroller-polyfill/dist/cjs-ponyfill');
        AbortController = polyfill.AbortController;
    }
}
module.exports = AbortController;
//# sourceMappingURL=abort-controller.js.map